import { TabPanel } from 'react-tabs';
import styled from '@emotion/styled';
import { css } from '@emotion/core';

const ProfileTabPanel = styled(TabPanel)(
  ({ theme }) => css`
    margin-bottom: 0;
    border-top-left-radius: 0;
    border-top-right-radius: 0;
    margin-top: 0;
    border-radius: ${theme.radii.sm};
    box-shadow: ${theme.elevations[1]};
    background: ${theme.colors.white};
  `
);

export default ProfileTabPanel;
// This is to let the Tabs component know this is a custom TabPanel

ProfileTabPanel.tabsRole = 'TabPanel';
